// extracted by mini-css-extract-plugin
export default {"cardBgColor":"style_cardBgColor__btIWe","p_13":"style_p_13__o42qp","p_16":"style_p_16__yPVuU","fontSize_14":"style_fontSize_14__bFrD7","cardShadow":"style_cardShadow__L1PKc"};